import { CommonModule } from "@angular/common";
import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	HostListener,
	OnDestroy,
	ViewEncapsulation,
} from "@angular/core";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { Store } from "@ngrx/store";
import { OpenIdConnectCacheService } from "@obg/common.verification";
import { CommonState } from "@obg/ngx.common";
import { GoogleAuthTransactionAction } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { DeviceConfigService } from "@obg/ngx.global";
import { RouteSelector } from "@obg/ngx.router";
import { ImageContentDirectiveModule } from "@obg/ngx.ui.core";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";

import { LoginFeatureState } from "../../../sdk";

@Component({
	selector: "obg-google-login",
	templateUrl: "./google-login.component.html",
	styleUrls: ["./google-login.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	standalone: true,
	imports: [CommonModule, MatButtonModule, CoreContentModule, ImageContentDirectiveModule],
})
export class GoogleLoginComponent implements OnDestroy {
	@HostBinding("attr.test-id") testId = "google-login-button";
	@HostBinding("class.obg-m-google-login") hostCssClass = true;

	private subscriptions$$ = new Subscription();

	constructor(
		private store: Store<LoginFeatureState & CommonState>,
		private googleAuthTransactionAction: GoogleAuthTransactionAction,
		private deviceConfigService: DeviceConfigService,
		private openIdConnectCacheService: OpenIdConnectCacheService
	) {}

	ngOnDestroy(): void {
		this.subscriptions$$.unsubscribe();
	}

	@HostListener("click")
	onClick() {
		const init$$ = this.setReturnUrl$()
			.pipe(
				tap(() =>
					this.store.dispatch(
						this.googleAuthTransactionAction.initializeOidcAuthTransaction({ provider: "google" })
					)
				)
			)
			.subscribe();

		this.subscriptions$$.add(init$$);
	}

	private setReturnUrl$() {
		return this.store.pipe(
			RouteSelector.getCurrent$,
			tap((currentRoute) => {
				if (currentRoute?.queryParams?.returnUrl) {
					this.openIdConnectCacheService.setReturnUrl(currentRoute?.queryParams?.returnUrl);
					return;
				}
				if (this.deviceConfigService.isDesktop()) {
					this.openIdConnectCacheService.setReturnUrl(currentRoute.pathName);
					return;
				}
				this.openIdConnectCacheService.setReturnUrl("/");
			})
		);
	}
}
